import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsentPlugin from "vanilla-cookieconsent";

export default class CookieConsent {
  constructor() {
    /**
     * All config. options available here:
     * https://cookieconsent.orestbida.com/reference/configuration-reference.html
     */
    // CookieConsentPlugin.run({
    //   onConsent: this.onConsent,
    //   onChange: this.onCookieConsentChange,
    //   guiOptions: {
    //     consentModal: {
    //       layout: "box",
    //       position: "bottom left",
    //       equalWeightButtons: true,
    //       flipButtons: false,
    //     },
    //     preferencesModal: {
    //       layout: "bar wide",
    //       position: "right",
    //       equalWeightButtons: true,
    //       flipButtons: false,
    //     },
    //   },
    //   categories: {
    //     necessary: {
    //       enabled: true, // this category is enabled by default
    //       readOnly: true, // this category cannot be disabled
    //     },
    //     analytics: {
    //       autoClear: {
    //         cookies: [{ name: /^(_ga|_gid)/ }],
    //       },
    //       services: {
    //         ga4: {
    //           label: "Google Analytics 4",
    //         },
    //       },
    //     },
    //   },
    //
    //   language: {
    //     default: "en",
    //     translations: {
    //       en: {
    //         consentModal: {
    //           title: "We use cookies",
    //           description: "Cookie modal description",
    //           acceptAllBtn: "Accept all",
    //           acceptNecessaryBtn: "Reject all",
    //           showPreferencesBtn: "Manage Individual preferences",
    //           footer:
    //             '<a href="#link">Privacy Policy</a>\n<a href="#link">Terms and conditions</a>',
    //         },
    //         preferencesModal: {
    //           title: "Consent Preferences Center",
    //           acceptAllBtn: "Accept all",
    //           acceptNecessaryBtn: "Reject all",
    //           savePreferencesBtn: "Save preferences",
    //           closeIconLabel: "Close modal",
    //           serviceCounterLabel: "Service|Services",
    //           sections: [
    //             {
    //               title: "Cookie Usage",
    //               description:
    //                 "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //             },
    //             {
    //               title:
    //                 'Strictly Necessary Cookies <span class="pm__badge">Always Enabled</span>',
    //               description:
    //                 "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //               linkedCategory: "necessary",
    //             },
    //             {
    //               title: "Analytics Cookies",
    //               description:
    //                 "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //               linkedCategory: "analytics",
    //             },
    //             {
    //               title: "Marketing Cookies",
    //               description:
    //                 "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //               linkedCategory: "marketing",
    //             },
    //             {
    //               title: "More information",
    //               description:
    //                 'For any queries in relation to our policy on cookies and your choices, please <a href="/contact">contact us</a>',
    //             },
    //           ],
    //         },
    //       },
    //       fr: {
    //         consentModal: {
    //           title: "Bonjour voyageur, c'est l'heure des cookies!",
    //           description:
    //             "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.",
    //           acceptAllBtn: "Accepter tout",
    //           acceptNecessaryBtn: "Tout rejeter",
    //           showPreferencesBtn: "Gérer les préférences",
    //           footer:
    //             '<a href="#link">Politique de confidentialité</a>\n<a href="#link">Termes et conditions</a>',
    //         },
    //         preferencesModal: {
    //           title: "Préférences de cookies",
    //           acceptAllBtn: "Accepter tout",
    //           acceptNecessaryBtn: "Tout rejeter",
    //           savePreferencesBtn: "Sauver les préférences",
    //           closeIconLabel: "Fermer la modale",
    //           serviceCounterLabel: "Services",
    //           sections: [
    //             {
    //               title: "Utilisation de Cookies",
    //               description:
    //                 "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //             },
    //             {
    //               title:
    //                 'Cookies Strictement Nécessaires <span class="pm__badge">Toujours Activé</span>',
    //               description:
    //                 "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //               linkedCategory: "necessary",
    //             },
    //             {
    //               title: "Cookies Analytiques",
    //               description:
    //                 "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //               linkedCategory: "analytics",
    //             },
    //             {
    //               title: "Cookies Publicitaires",
    //               description:
    //                 "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //               linkedCategory: "marketing",
    //             },
    //             {
    //               title: "Plus d'informations",
    //               description:
    //                 'For any query in relation to my policy on cookies and your choices, please <a href="/contact">contact us</a>.',
    //             },
    //           ],
    //         },
    //       },
    //     },
    //     autoDetect: "document",
    //   },
    // });
    // CookieConsentPlugin.show();
  }

  onConsent() {
    if (CookieConsentPlugin.acceptedService("ga4", "analytics")) {
      gtag("consent", "update", {
        analytics_storage: "granted",
        ad_storage: "granted",
      });
    }
  }

  onCookieConsentChange({ changedCategories, changedServices }) {
    if (changedCategories.includes("analytics")) {
      if (changedServices["analytics"].includes("Google Analytics 4")) {
        if (
          CookieConsentPlugin.acceptedService("Google Analytics 4", "analytics")
        ) {
          gtag("consent", "update", {
            analytics_storage: "granted",
            ad_storage: "granted",
          });
        } else {
          gtag("consent", "update", {
            analytics_storage: "denied",
            ad_storage: "denied",
          });
        }
      }
    }
  }
}
